<template>
  <div>
    <el-button
      type="primary"
      icon="el-icon-plus"
      @click="dialogVisible = true"
    >
      添加空投任务
    </el-button>
    <el-dialog
      :visible="dialogVisible"
      title="添加空投任务"
      width="600px"
      @close="closeDialog"
    >
      <el-form :model="task" ref="form" :rules="rules" label-width="150px">
        <el-form-item label="余额变更类型：" prop="type">
          <el-select v-model="task.type" placeholder="请选择">
            <el-option
              v-for="item in taskType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="空投账号ID：" prop="airdropUserId">
          <el-input v-model="task.airdropUserId"></el-input>
        </el-form-item>
        <el-form-item label="转出余额类型：" prop="fromType">
          <el-select v-model="task.fromType" placeholder="请选择">
            <el-option
              v-for="item in taskBalanceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="转入余额类型：" prop="toType">
          <el-select v-model="task.toType" placeholder="请选择">
            <el-option
              v-for="item in taskBalanceType"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="是否发送通知：" prop="isSendNotice">
          <el-checkbox v-model="task.isSendNotice"></el-checkbox>
        </el-form-item>
        <el-form-item label="通知内容：" prop="noticeContent">
          <el-input type="textarea" v-model="task.noticeContent"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSave()">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'CreateAirdropTask',
  data() {
    return {
      dialogVisible: false,
      task: {
        isSendNotice: false
      },
      rules:{
        type: [
            { required: true, message: '请选择余额变更类型', trigger: 'blur' },
            
          ],
        fromType: [
            { required: true, message: '请选择转出余额类型', trigger: 'blur' },
            
          ],
        toType: [
            { required: true, message: '请选择转入余额类型', trigger: 'blur' },
            
          ],
        airdropUserId: [
            { required: true, message: '请输入空投账号ID', trigger: 'blur' },
            
          ],
      }
    };
  },
  computed: {
    ...mapState('airdrop', ['taskType', 'taskBalanceType'])
  },
  methods: {
    ...mapActions('airdrop', ['create']),
    closeDialog() {
      this.dialogVisible = false;
      this.task = {};
      this.$refs['form'].resetFields();
    },
    handleSave() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          this.create(this.task).then(() => {
            this.$message({
              message: '添加成功！',
              type: 'success'
            });
            this.dialogVisible = false;
            this.$emit('onSuccess');
          });
        }
      });
    }
  }
};
</script>

<style lang="less">
</style>
